(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desktop-filter-bar"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Hide original filters when desktop control bar is present
    const desktopBar = document.querySelector('.desktop-filter-control-bar');
    if (desktopBar) {
      const originalFilters = document.querySelectorAll('.facets-block-wrapper, .facets-toggle');
      originalFilters.forEach(filter => {
        filter.style.display = 'none';
      });
    }

    // Grid layout switching with text update
    const gridInputs = document.querySelectorAll('.desktop-filter-control-bar .grid-input');
    const gridViewLabel = document.querySelector('.grid-view-label');
    
    gridInputs.forEach(input => {
      input.addEventListener('change', function() {
        const gridValue = this.value;
        
        // Update grid view text
        if (gridViewLabel) {
          if (gridValue === 'default') {
            gridViewLabel.textContent = '4\'lü Gösterim';
          } else if (gridValue === 'zoom-out') {
            gridViewLabel.textContent = '3\'lü Gösterim';
          }
        }
        
        // Find the product grid
        const productGrid = document.querySelector('.product-grid');
        if (productGrid) {
          // Update grid attribute
          productGrid.setAttribute('product-grid-view', gridValue);
          
          // Trigger multiple events to ensure compatibility
          const events = [
            new CustomEvent('results-list/updateLayout', { detail: { value: gridValue } }),
            new CustomEvent('grid:update', { detail: { layout: gridValue } }),
            new CustomEvent('product-grid:change', { detail: { view: gridValue } })
          ];
          
          events.forEach(event => document.dispatchEvent(event));
          
          // Direct CSS class manipulation as fallback
          if (gridValue === 'zoom-out') {
            productGrid.classList.add('product-grid--dense');
            productGrid.classList.remove('product-grid--default');
          } else {
            productGrid.classList.add('product-grid--default');
            productGrid.classList.remove('product-grid--dense');
          }
          
          // Force re-render by triggering a style recalculation
          productGrid.style.display = 'none';
          productGrid.offsetHeight; // Trigger reflow
          productGrid.style.display = '';
        }
        
        // Also try to find and trigger existing grid controls
        const existingGridInputs = document.querySelectorAll('input[name="grid"]:not(.desktop-filter-control-bar input)');
        existingGridInputs.forEach(existingInput => {
          if (existingInput.value === gridValue) {
            existingInput.checked = true;
            existingInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        
        // Additional fallback: directly manipulate grid styles
        setTimeout(() => {
          const grid = document.querySelector('.product-grid');
          if (grid) {
            if (gridValue === 'zoom-out') {
              grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
              grid.style.setProperty('--product-grid-columns-desktop', 'repeat(3, 1fr)', 'important');
              grid.style.setProperty('gap', '24px', 'important');
            } else {
              grid.style.setProperty('grid-template-columns', 'repeat(4, 1fr)', 'important');
              grid.style.setProperty('--product-grid-columns-desktop', 'repeat(4, 1fr)', 'important');
              grid.style.setProperty('gap', '20px', 'important');
            }
          }
        }, 100);
      });
    });

    // Sorting dropdown functionality
    const sortingDropdowns = document.querySelectorAll('.desktop-filter-control-bar .sorting-dropdown');
    sortingDropdowns.forEach(dropdown => {
      const summary = dropdown.querySelector('.sorting-summary');
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
          dropdown.removeAttribute('open');
        }
      });
      
      // Handle sorting with instant update
      const sortingOptions = dropdown.querySelectorAll('.sorting-option');
      sortingOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          
          const sortValue = this.dataset.sortValue;
          const sortName = this.dataset.sortName;
          
          // Update UI immediately
          summary.querySelector('.sorting-current-text').textContent = sortName;
          dropdown.removeAttribute('open');
          
          // Create URL with sort parameter
          const url = new URL(window.location);
          url.searchParams.set('sort_by', sortValue);
          
          // Use fetch to update products without full page reload
          fetch(url.toString())
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(html, 'text/html');
              
              // Update product grid
              const currentGrid = document.querySelector('.product-grid');
              const newGrid = newDoc.querySelector('.product-grid');
              if (currentGrid && newGrid) {
                currentGrid.innerHTML = newGrid.innerHTML;
              }
              
              // Update pagination if exists
              const currentPagination = document.querySelector('.pagination');
              const newPagination = newDoc.querySelector('.pagination');
              if (currentPagination && newPagination) {
                currentPagination.innerHTML = newPagination.innerHTML;
              }
              
              // Update product count
              const newCount = newDoc.querySelector('.desktop-filter-control-bar .control-bar-section--count .control-bar-text');
              const currentCount = document.querySelector('.desktop-filter-control-bar .control-bar-section--count .control-bar-text');
              if (newCount && currentCount) {
                currentCount.textContent = newCount.textContent;
              }
              
              // Update browser history
              window.history.pushState({}, '', url.toString());
            })
            .catch(error => {
              console.error('Error updating products:', error);
              // Fallback to page reload
              window.location.href = url.toString();
            });
        });
      });
    });

    // Mobile sorting functionality
    const mobileSortingBar = document.querySelector('.mobile-sorting-bar');
    const mobileSortingContent = document.querySelector('.mobile-sorting-content');
    const mobileSortingText = document.querySelector('.mobile-sorting-text');
    
    if (mobileSortingBar && mobileSortingContent) {
      // Toggle mobile dropdown
      mobileSortingContent.addEventListener('click', function() {
        mobileSortingBar.classList.toggle('active');
      });
      
      // Close mobile dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!mobileSortingBar.contains(e.target)) {
          mobileSortingBar.classList.remove('active');
        }
      });
      
      // Handle mobile sorting selection
      const mobileSortingOptions = document.querySelectorAll('.mobile-sorting-option');
      mobileSortingOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          
          const sortValue = this.dataset.sortValue;
          const sortName = this.dataset.sortName;
          
          // Update mobile UI
          if (mobileSortingText) {
            mobileSortingText.textContent = sortName;
          }
          mobileSortingBar.classList.remove('active');
          
          // Create URL with sort parameter
          const url = new URL(window.location);
          url.searchParams.set('sort_by', sortValue);
          
          // Use fetch to update products without full page reload
          fetch(url.toString())
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(html, 'text/html');
              
              // Update product grid
              const currentGrid = document.querySelector('.product-grid');
              const newGrid = newDoc.querySelector('.product-grid');
              if (currentGrid && newGrid) {
                currentGrid.innerHTML = newGrid.innerHTML;
              }
              
              // Update pagination if exists
              const currentPagination = document.querySelector('.pagination');
              const newPagination = newDoc.querySelector('.pagination');
              if (currentPagination && newPagination) {
                currentPagination.innerHTML = newPagination.innerHTML;
              }
              
              // Update desktop control bar if exists
              const desktopSortingText = document.querySelector('.desktop-filter-control-bar .sorting-current-text');
              if (desktopSortingText) {
                desktopSortingText.textContent = sortName;
              }
              
              // Update browser history
              window.history.pushState({}, '', url.toString());
            })
            .catch(error => {
              console.error('Error updating products:', error);
              // Fallback to page reload
              window.location.href = url.toString();
            });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !window.DesignMode) return;
  try {
    
  // Video-reels sepete ekleme event handling
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Video-reels debug: DOM loaded');
    
    // Listen for cart add events
    document.addEventListener('cart:update', function(e) {
      console.log('Video-reels debug: CartAddEvent fired!', e.detail);
      console.log('Video-reels debug: Event source:', e.detail.data?.source);
      console.log('Video-reels debug: Item count:', e.detail.data?.itemCount);
    });
    
    const buttons = document.querySelectorAll('.shoppable-video__add-button');
    console.log('Video-reels debug: Found buttons:', buttons.length);
    
    buttons.forEach((button, index) => {
      console.log(`Video-reels debug: Setting up button ${index}`, button);
      
      button.addEventListener('click', function(e) {
        console.log('Video-reels debug: Button clicked!', e.target);
        console.log('Video-reels debug: Button disabled?', button.disabled);
        
        // Check if form submission is being prevented
        const form = button.closest('product-form-component');
        const variantInput = form?.querySelector('input[name="id"]');
        console.log('Video-reels debug: Variant ID:', variantInput?.value);
        
        // Check if the components are properly connected
        const addToCartComponent = button.closest('add-to-cart-component');
        const productFormComponent = button.closest('product-form-component');
        
        // Prevent default form submission
        e.preventDefault();
        console.log('Video-reels debug: Form submission prevented');
        
        // Manual AJAX cart add to bypass all form submit issues
        const variantId = variantInput?.value;
        if (variantId) {
          console.log('Video-reels debug: Making direct AJAX request to add to cart...');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Video-reels debug: Cart add successful:', data);
            
            // Trigger cart update event manually
            const cartUpdateEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: data,
                sourceId: 'video-reels',
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  variantId: variantId
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);
            
            // Trigger add to cart animation
            if (addToCartComponent && typeof addToCartComponent.animateAddToCart === 'function') {
              addToCartComponent.animateAddToCart();
            }
          })
          .catch(error => {
            console.error('Video-reels debug: Cart add failed:', error);
          });
        } else {
          console.log('Video-reels debug: No variant ID found');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
